import React from 'react';
import { FeatureItem, PricingCard, Section, SectionHeader, useScrollReveal } from '../ui';
import { CheckIcon } from '../ui/icons';

// eslint-disable-next-line import/prefer-default-export
export function Pricing() {
  const employerCheckIcon = (
    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white ring-2 ring-tertiary text-tertiary">
      <CheckIcon className="w-4 h-4" />
    </span>
  );
  const employerRef = useScrollReveal();
  const agencyRef = useScrollReveal();

  const baseDesc = (
    <>
      Max 5 orders.
      <br />
      5 candidates per role.
      <br />
      10% service fee per placement.
    </>
  );
  const plusDesc = (
    <>
      Max 10 orders.
      <br />
      5 candidates per role.
      <br />
      5% service fee per placement.
    </>
  );
  const proDesc = (
    <>
      Unlimited orders.
      <br />
      10 candidates per role.
      <br />
      5% service fee per placement.
    </>
  );

  return (
    <Section variant="default" id="pricing">
      <div className="max-w-6xl mx-auto px-4">
        <SectionHeader
          title="Pricing Overview"
          subtitle="Fair, transparent pricing for everyone."
          subtitleTag="h3"
        />
        <div className="space-y-16 max-w-5xl mx-auto">
          <div className="space-y-8">
            <h3 className="text-slate-900 border-b border-slate-200 pb-4 text-center">Employers</h3>
            <div ref={employerRef} className="grid md:grid-cols-3 gap-6">
              <div className="scroll-reveal">
                <FeatureItem
                  icon={employerCheckIcon}
                  title="Free to post. Really."
                  description="No upfront cost to list your roles on our marketplace."
                  layout="horizontal"
                  variant="success"
                  removeIconBackground
                  isCard
                  hoverBgOnly
                />
              </div>
              <div className="scroll-reveal">
                <FeatureItem
                  icon={employerCheckIcon}
                  title="Pay only upon successful hire"
                  description="A pay-per-hire, contingency-based fee model based on your posted budget for hiring via agencies."
                  layout="horizontal"
                  variant="success"
                  removeIconBackground
                  isCard
                  hoverBgOnly
                />
              </div>
              <div className="scroll-reveal">
                <FeatureItem
                  icon={employerCheckIcon}
                  title="Optional upgrades"
                  description="Premium features available."
                  layout="horizontal"
                  variant="success"
                  removeIconBackground
                  isCard
                  hoverBgOnly
                />
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-slate-900 border-b border-slate-200 pb-4 mb-8 text-center">
              Agencies
            </h3>
            <div ref={agencyRef} className="grid md:grid-cols-3 gap-6">
              <div className="scroll-reveal">
                <PricingCard name="Base" price={0} variant="primary" description={baseDesc} />
              </div>
              <div className="scroll-reveal">
                <PricingCard name="Plus" price={20} variant="secondary" description={plusDesc} />
              </div>
              <div className="scroll-reveal">
                <PricingCard name="Pro" price={50} variant="tertiary" description={proDesc} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
